export const formActions = {
	cancel: "Fermer",
	create: "Terminer l'enregistrement",
	save: "Enregistrer les modifications",
	validationError: {
		title: "Échec de la validation du formulaire",
		description:
			"Veuillez corriger {{count}} erreur(s) dans les onglets suivants : {{tabs}}",
	},
};
